import React from 'react';
import { object, oneOf } from 'prop-types';

import { CategoriesDesktopMenu, CategoriesMobileMenu } from '../../../../../components';
import { useIntl } from 'react-intl';

const CategoriesMenu = ({ config, layout }) => {
  const intl = useIntl();
  const { categories = [] } = config?.categoryConfiguration || {};

  if (layout === 'mobile') {
    return <CategoriesMobileMenu intl={intl} categories={categories} />;
  }

  return <CategoriesDesktopMenu intl={intl} categories={categories} />;
};

CategoriesMenu.defaultProps = {
  layout: 'desktop',
};

CategoriesMenu.propTypes = {
  config: object,
  layout: oneOf(['desktop', 'mobile']),
};

export default CategoriesMenu;
